import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  IconButton,
} from '@mui/material';
import { Fragment, FunctionComponent } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getNote } from '../api/getNote';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { completeNote } from '../api/completeNote';
import LoadingButton from '@mui/lab/LoadingButton';

export const NoteViewPage: FunctionComponent = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isLoading, data: note } = useQuery(['note', id], () =>
    getNote(id || '')
  );
  const queryClient = useQueryClient();

  const completeMutation = useMutation(completeNote, {
    onSuccess: () => {
      queryClient.invalidateQueries('notes');
      navigate('/notes');
    },
  });

  if (isLoading) return <>loading...</>;

  if (!note) throw Error();

  return (
    <Card>
      <CardHeader
        titleTypographyProps={{
          variant: 'h6',
          textAlign: 'center',
        }}
        title={note.title}
        action={
          <Link to="/notes">
            <IconButton>
              <CloseIcon />
            </IconButton>
          </Link>
        }
        sx={{ pb: 1 }}
      />
      <CardContent sx={{ p: 1 }}>
        {note.body.split('\n').map((l) => (
          <Fragment key={l}>
            {l}
            <br />
          </Fragment>
        ))}
      </CardContent>
      <CardActions>
        <LoadingButton
          variant="outlined"
          startIcon={<CheckIcon />}
          onClick={() => {
            // eslint-disable-next-line no-restricted-globals
            if (confirm('Complete Workout?')) completeMutation.mutate(note);
          }}
          loading={completeMutation.isLoading}
          loadingPosition="start"
        >
          Complete
        </LoadingButton>
      </CardActions>
    </Card>
  );
};
